module.exports = __webpack_public_path__ + "img/ball-1.884f1283.png";